var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import { Button } from "./..";
import { LabelWithToggle } from './LabelWithToggle';
export var DropdownButton = forwardRef(function (_a, ref) {
    var label = _a.label, _b = _a.showToggleIndicator, showToggleIndicator = _b === void 0 ? false : _b, _c = _a.isOutlineToggle, isOutlineToggle = _c === void 0 ? false : _c, _d = _a.isOpen, isOpen = _d === void 0 ? false : _d, ariaLabel = _a.ariaLabel, _e = _a.isFullscreen, isFullscreen = _e === void 0 ? false : _e, otherProps = __rest(_a, ["label", "showToggleIndicator", "isOutlineToggle", "isOpen", "ariaLabel", "isFullscreen"]);
    return (React.createElement(Button, __assign({ type: "button", palette: isOpen ? 'secondary' : 'primary', emphasis: isOpen ? 'high' : 'medium' }, otherProps, { ref: ref, lss: __assign(__assign({}, otherProps.lss), { whiteSpace: 'nowrap', textTransform: 'capitalize', textOverflow: 'ellipsis', overflow: 'hidden' }), "aria-haspopup": "true", "aria-expanded": isOpen, "aria-controls": ariaLabel, "aria-label": ariaLabel }), showToggleIndicator ? (React.createElement(LabelWithToggle, { isOpen: isOpen, label: label, isOutlineToggle: isOutlineToggle, isFullscreen: isFullscreen })) : (label)));
});
//# sourceMappingURL=DropdownButton.js.map